import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";


export class ChangeEndDateCommand {
  constructor(private readonly dispatcher: CommandDispatcher) {}

  run(contract_id: number, end_date: string, reason: string, staff_username: string): Promise<{ [key: string]: object; }> {
    return this.dispatcher.dispatch('change.end.date', {
      contract_id, end_date, reason, staff_username
    });
  }
}